import React from 'react';
import moment from 'moment';
import Event from './Event';
import StartEvent from './StartEvent';

function EventList({ events, start, language }) {
	const sortedEvents = events.sort((a, b) => moment(a.fields.begin).diff(b.fields.begin));
	const startEvents = events.slice(0, 3);
	return (
		<React.Fragment>
			{events.length !== 0 ? start ? (
				startEvents.map((event, index) => {
					return <StartEvent event={event} key={index} language={language} />;
				})
			) : (
				sortedEvents.map((event, index) => {
					return <Event event={event} key={index} language={language} />;
				})
			) : (
				<div className="no-event-grid">
					<div className="no-events">Keine anstehenden Termine</div>
				</div>
			)}
		</React.Fragment>
	);
}

export default EventList;
